import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './locales'
import VueMeta from 'vue-meta'

Vue.config.productionTip = false
Vue.use(VueMeta)

var sprintf = require("sprintf-js").sprintf
Vue.prototype.$sprintf = sprintf

new Vue({
  i18n,
  router,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount("#app");